import React from 'react';
import { Paper, Box, Typography, Stack } from '@mui/material';

const COLOR_BY_TONE = {
  positive: '#16a34a',
  warning: '#f59e0b',
  negative: '#dc2626',
  info: '#3b82f6',
  neutral: '#475569',
};

export default function KpiCard({ label, value, sub, tone = 'neutral', icon: Icon }) {
  const accent = COLOR_BY_TONE[tone] || COLOR_BY_TONE.neutral;
  return (
    <Paper sx={{ p: 2, height: '100%', borderLeft: `4px solid ${accent}` }}>
      <Stack direction="row" alignItems="flex-start" spacing={1.5}>
        {Icon ? (
          <Box sx={{ color: accent, mt: 0.5 }}>
            <Icon fontSize="small" />
          </Box>
        ) : null}
        <Box flex={1} minWidth={0}>
          <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.4 }}>
            {label}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 600, lineHeight: 1.2, mt: 0.25 }}>
            {value}
          </Typography>
          {sub != null && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
              {sub}
            </Typography>
          )}
        </Box>
      </Stack>
    </Paper>
  );
}
